import React from 'react'
import { Stack } from 'react-bootstrap'
import { Form } from '@ztechapps/webui.form'
import { useQuickAddTaskContext } from './Context'

export const QuickAddTaskLayout = () => {
  const { initialValues, validate, onSubmit, onReset, components } = useQuickAddTaskContext()

  return (
    <Form initialValues={initialValues} onSubmit={onSubmit} validate={validate} onReset={onReset}>
      <Stack gap={3}>
        <components.formInput />
        <div>
          <components.saveCancelButtons />
        </div>
      </Stack>
    </Form>
  )
}
